/* tslint:disable */
/* eslint-disable */
/* @relayHash f4e9af0291f2309ff1e086ef93627e1a */

import { ConcreteRequest } from "relay-runtime";
export type RemoveStoryExpertInput = {
    clientMutationId: string;
    storyID: string;
    userID: string;
};
export type RemoveExpertMutationVariables = {
    input: RemoveStoryExpertInput;
};
export type RemoveExpertMutationResponse = {
    readonly removeStoryExpert: {
        readonly story: {
            readonly id: string;
            readonly settings: {
                readonly experts: ReadonlyArray<{
                    readonly id: string;
                    readonly username: string | null;
                    readonly email: string | null;
                }>;
            };
        };
        readonly clientMutationId: string;
    };
};
export type RemoveExpertMutation = {
    readonly response: RemoveExpertMutationResponse;
    readonly variables: RemoveExpertMutationVariables;
};



/*
mutation RemoveExpertMutation(
  $input: RemoveStoryExpertInput!
) {
  removeStoryExpert(input: $input) {
    story {
      id
      settings {
        experts {
          id
          username
          email
        }
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RemoveStoryExpertPayload",
            "kind": "LinkedField",
            "name": "removeStoryExpert",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoralUser",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "username",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "email",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RemoveExpertMutation",
            "selections": (v2 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RemoveExpertMutation",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "id": "f4e9af0291f2309ff1e086ef93627e1a",
            "metadata": {},
            "name": "RemoveExpertMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '9eabe8d3ef208e9838cea50ff3732933';
export default node;
